import * as React from 'react';

export class PanelDividerLine extends React.Component<{}> {

    public render(): React.ReactNode {
        return (
            <div className="w-100">
                <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PanelDividerLine.tsx